// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__6tSQD","content":"styles_content__QNXbX"};